import React from "react";
import { useTranslation } from "react-i18next";
import StreamAnimation from "../components/StreamLoading";
import UpdatingAnimation from "../components/UpdatingAnimation";
const Admin: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center mt-[10%]">
      <div className="w-[30%] height-[25%]">
        <UpdatingAnimation />
      </div>
    </div>
  );
};

export default Admin;
